import React, { useEffect, useState } from 'react';
import '../css/patchnotes.css';

const PatchNotesModal = ({ isOpen, onClose }) => {
  const [notes, setNotes] = useState(null);

  useEffect(() => {
    if (!isOpen) return;

    const fetchNotes = async () => {
      const res = await fetch('/api/notes/patchnotes');
      const data = await res.json();
      setNotes(data.text);
    };

    fetchNotes();
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="patchModalOverlay">
      <div className="patchModalContent">
        <button className="closeButton" onClick={onClose}>×</button>
        <h2>Patch Notes</h2>
        <pre className="patchText">{notes || 'Loading...'}</pre>
      </div>
    </div>
  );
};

export default PatchNotesModal;
